import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "./CTAButton.scss";
import WhiteButton from "../WhiteButton/WhiteButton";

function CTAButton(props) {
  var CTA_PINK_HOVER_COLOR = "#FF5B91";
  var CTA_PURPLE_HOVER_COLOR = "#8358e8";
  var hoverColors = {
    pink: CTA_PINK_HOVER_COLOR,
    purple: CTA_PURPLE_HOVER_COLOR,
  };
  return (
    <WhiteButton
      className={
        "cta-btn" +
        (props.color ? " cta-btn-" + props.color : "") +
        (props.className ? " " + props.className : "")
      }
      style={props.style}
      hoverColor={hoverColors[props.color]}
      text={props.text}
      onClick={props.onClick}
      href={props.href}
    ></WhiteButton>
  );
}

export default CTAButton;
